import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createGroupRoomFormCreateReduceObject } from './createGroupRoom/createGroupRoomForm';
import sendFeedbackSaga from './createGroupRoom/sagas/createGroupRoomFormSaga';

export default [
  // Forms
  ...createCombineMapItem(
    'createRoomForm',
    createGroupRoomFormCreateReduceObject,
    [sendFeedbackSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/forms/reducersMap.js